module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-7b4f2aa0.png";